export default __webpack_public_path__ + "static/media/amaze-16.2a34d9ca.jpg";